import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Picture } from 'formlabs-web-components/Media';
import { Eyebrow, Caption } from 'formlabs-web-components/Type';
import { Link } from 'formlabs-web-components/Link';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import TextPlugin from '../cms/TextPlugin';

import './Card.module.css';

class Card extends PureComponent {
  render() {
    const {
      image,
      children,
      caption,
      eyebrowText,
      labelText,
      overlayText,
      bgColor,
      padding,
      body,
      imagePosition,
      border,
      url,
      imageConstraint,
      hover,
      micro,
      webinars,
      imageAlt,
      classes
    } = this.props;
    const cardContent = (
      <div
        styleName={classNames('card', imagePosition, { border: border })}
        style={{
          padding: padding
        }}
      >
        <div
          styleName="card-image"
          style={{
            width:
              imageConstraint && imagePosition === 'left'
                ? imageConstraint
                : 'auto'
          }}
        >
          {labelText && <div styleName="label-1">{labelText}</div>}
          <div styleName="text-overlay">
            {overlayText && <p>{overlayText}</p>}
          </div>
          {image && <Picture largeImage={image} width="100%" alt={imageAlt} />}
        </div>
        <div styleName="card-body">
          {caption && <Caption>{caption}</Caption>}
          {eyebrowText && <Eyebrow styleName="label-2">{eyebrowText}</Eyebrow>}
          <div styleName="content">
            <TextPlugin body={body} />
            {children}
          </div>
        </div>
      </div>
    );
    return (
      <div
        styleName={classNames('card-wrapper', bgColor, {
          micro,
          [`${hover}-hover`]: hover,
          webinars
        })}
        className={classes}
      >
        {url ? (
          <Link to={url} openExternalInNewWindow>
            {cardContent}
          </Link>
        ) : (
          cardContent
        )}
      </div>
    );
  }
}

Card.propTypes = {
  children: PropTypes.any,
  /** Caption that appears below the card image */
  caption: PropTypes.string,
  /** Eyebrow text that goes above body area */
  eyebrowText: PropTypes.string,
  /** Label text that appears in upper left corner of the card image. */
  labelText: PropTypes.string,
  /** Adds text on top of image in lower left */
  overlayText: PropTypes.string,
  /** changes the background color of the card and text to match */
  bgColor: PropTypes.string,
  /** Adds padding to the card */
  padding: PropTypes.string,
  /** Main text of the card */
  body: PropTypes.node,
  /** Determines if image will be above or to the side of the body area */
  imagePosition: PropTypes.string,
  /** Determines whether to display grey border around the whole card or not */
  border: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** Url for the large image in the card */
  image: PropTypes.string,
  /** Links the entire card to the designated URL */
  url: PropTypes.string.isRequired,
  /** Restricts width of image. */
  imageConstraint: PropTypes.string
};

export default DisplayComponent(Card);
